import { connect } from 'react-redux'
import { compose, withHandlers, withState, lifecycle } from 'recompose'
import qs from 'query-string'

import * as UserSelectors from 'modules/user/selectors'
import { isExtensionInstalled } from 'utils/extension'
import { Flow } from 'constants/flowConstants'
import config from 'config'

import TouchlessStart from './component'

const mapStateToProps = state => ({
  flow: UserSelectors.getFlow(state),
})

export default compose(
  connect(mapStateToProps),
  withState('loginUrl', 'setLoginUrl', `${config.START_WEB_URL}/login`),
  lifecycle({
    async componentDidMount() {
      if (this.props.flow === Flow.VIDEO) {
        let redirect
        const hasExtension = await isExtensionInstalled()

        if (hasExtension) {
          redirect = `${config.LETS_GO_URL}/letsgo/video/landing`
        } else {
          redirect = `${config.LETS_GO_URL}/letsgo/video/extension`
        }
        this.props.setLoginUrl(`${config.START_WEB_URL}/login?${qs.stringify({ redirect })}`)
      }
    }
  }),
  withState('keystrokeCounter', 'setKeystrokeCounter', 0),
  withState('interactiveColor', 'setInteractiveColor', false),
  withState('startTimer', 'setStartTimer', new Date()),
  withState('displayChatNumber', 'setDisplayChatNumber', 0),
  withState('initialInterval', 'setInitialInterval', props => setInterval(() => props.setDisplayChatNumber(Math.floor(Math.random() * 8)),2000)),
  withHandlers({
    onValueChange: props => () => {
      props.setInteractiveColor(true)
      clearInterval(props.initialInterval)
      props.setKeystrokeCounter(props.keystrokeCounter + 1)
      if ((props.keystrokeCounter >= 2) && (new Date() - props.startTimer > 1000)) {
        props.setKeystrokeCounter(0)
        props.setDisplayChatNumber(Math.floor(Math.random() * 8))
        props.setStartTimer(new Date())
      }
    },
  })
)(TouchlessStart)



// WEBPACK FOOTER //
// ./src/layouts/TouchlessStart/index.js